export default (index: number, brackets: number[]) => {
  const curValue = Number(brackets[index]);
  if (!curValue) {
    return '';
  }

  if (index === 0) {
    if (curValue > 1) {
      return `0 - ${curValue - 1}`;
    } else {
      return '0';
    }
  } else {
    const prev = brackets
      .slice(0, index)
      .reduce((acc, curr) => acc + (Number(curr) || 0), 0);

    if (curValue === 1) {
      return prev;
    } else {
      return `${prev} - ${prev + curValue - 1}`;
    }
  }
};
